import Network from '@/services/network';

export default function handleActivities() {
    const network = new Network;

    const fetchActivityTree = (query) => {
        return network.api('get', `/procurement/activity-setup/setup-tree` + query);
    }

    const storeActivity = (data) => {
        return network.api('post', `/procurement/activity-setup/store-activity`, data);
    }

    const updateActivity = (data, id) => {
        return network.api('post', `/procurement/activity-setup/update-activity/${id}`, data);
    }

    const fetchSingleActivity = (id, query) => {
        return network.api('get', `/procurement/activity-setup/${id}/edit` + query);
    }

    const storeTaskActivityLog = (data, query) => {
        return network.api('post', `/procurement/activity-manager/store-activity-log`+query, data);
    }

    const fetchTaskActivityLog = (query) => {
        return network.api('get', '/procurement/activity-manager/task-activity-log' + query);
    }

    const fetchSingleTaskActivityLog = (id, query) => {
        return network.api('get', `/procurement/activity-manager/task-activity-log/${id}` + query);
    }

    const updateTaskActivityLog = (data, id) => {
        return network.api('post', `/procurement/activity-manager/update-activity-log/${id}`, data);
    }

    const updateDragTaskActivityLog = (id, data) => {
        return network.api('post', `/procurement/activity-manager/update-drag-activity-log/${id}`, data);
    }

    const updateMarkAsDoneTaskActivityLog = (data, id) => {
        return network.api('post', `/procurement/activity-manager/update-mark-as-done/${id}`, data);
    }

    const fetchTaskActivityWorkStatusLog = (id, query) => {
        return network.api('get', `/procurement/activity-manager/task-activity-work-status-log/${id}` + query);
    }

    const fetchTaskManagementList = (query) => {
        return network.api('get', '/procurement/activity-manager/task-management' + query);
    }

    const fetchClientTaskManagementList = (query) => {
        return network.api('get', '/procurement/activity-manager/client-task-management' + query);
    }

    const fetchTeamTaskManagementList = (query) => {
        return network.api('get', '/procurement/activity-manager/team-task-management' + query);
    }

    const updateActivityLogWorkStatus = (data, id) => {
        return network.api('post', `/procurement/activity-manager/activity-log-work-status/${id}`, data);
    }

    const fetchWorkStatusTimeSheet = (query) => {
        return network.api('get', '/procurement/activity-manager/work-status-timesheet' + query);
    }

    const fetchOrganizationActivityReport = (query) => {
        return network.api('get', '/procurement/activity-manager/organization-activity-report' + query);
    }

    return {
        fetchActivityTree,
        storeActivity,
        updateActivity,
        fetchSingleActivity,
        storeTaskActivityLog,
        fetchTaskActivityLog,
        fetchSingleTaskActivityLog,
        updateTaskActivityLog,
        updateDragTaskActivityLog,
        updateMarkAsDoneTaskActivityLog,
        fetchTaskManagementList,
        fetchClientTaskManagementList,
        fetchTeamTaskManagementList,
        updateActivityLogWorkStatus,
        fetchWorkStatusTimeSheet,
        fetchTaskActivityWorkStatusLog,
        fetchOrganizationActivityReport
    }
}
